import React from "react";
import withProviders from "../../hooks/withProviders";
import { FilterProvider, ManagementReportsLeagueTableDefaultFilters } from "../../hooks/FilterContext";
import ManagementReportsLeagueTable from "../../features/managementreportsleaguetable";
const ManagementReportsLeagueTablePage = () => <ManagementReportsLeagueTable />

export default withProviders([FilterProvider, { defaultFilters: ManagementReportsLeagueTableDefaultFilters, filterStore: 'management.reports.leaguetable' }])(ManagementReportsLeagueTablePage);
